import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { MatList, MatListItem, MatListItemLine, MatListItemTitle } from '@angular/material/list';
import { ProductBaseModel } from '@libs/shop/models';
import { ProductPriceVisibilityDirective } from '@libs/shared/ui';
import { ProductPriceFormatterComponent } from '../product-prices/product-price-formatter';

@Component({
  selector: 'ui-product-card-attributes',
  imports: [
    MatList,
    MatListItem,
    MatListItemLine,
    MatListItemTitle,
    ProductPriceFormatterComponent,
    ProductPriceVisibilityDirective,
  ],
  templateUrl: './product-card-attributes.component.html',
  styleUrl: './product-card-attributes.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCardAttributesComponent {
  public product: InputSignal<ProductBaseModel> = input.required();
  public showAdditionalData: InputSignal<boolean> = input(false);
}
